import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { AIReportCtaSectionImages } from "./images-part/AIReportCtaSectionImages";
import { AIReportCtaSectionText, CloseButton, StyledAIReportCtaSection } from "./StyledAIReportCtaSection";
import { AI_REPORT_CTA_SECTION_TRANSLATIONS } from "./translations";
import { useAIReportCtaSection } from "./useAIReportCtaSection";

export const AIReportCtaPlacement = {
    ANALYSIS: "analysis",
    PERFORMANCE: "performance",
} as const;

export type AIReportCtaPlacementValue = (typeof AIReportCtaPlacement)[keyof typeof AIReportCtaPlacement];

interface IAIReportCtaSectionProps {
    placement: AIReportCtaPlacementValue;
}

export const AIReportCtaSection = ({ placement }: IAIReportCtaSectionProps) => {
    const { isShown, handleDismissClicked, handleTalkToUsClicked } = useAIReportCtaSection({ placement });

    if (!isShown) {
        return null;
    }

    return (
        <StyledAIReportCtaSection data-automation="ai-report-cta-section">
            <CloseButton
                type="flat"
                onClick={handleDismissClicked}
            >
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[0]}
                    data-automation="ai-report-cta-section-close-button"
                >
                    ✕
                </Text>
            </CloseButton>

            <AIReportCtaSectionText>
                <Flex
                    gap="6px"
                    flexDirection="column"
                >
                    <Text
                        fontVariant="h5_2"
                        color={colorsPalettes.carbon[0]}
                    >
                        {translate(AI_REPORT_CTA_SECTION_TRANSLATIONS.WANT_A_CUSTOMIZED_RECOMMENTATION)}
                    </Text>

                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.midnight[50]}
                    >
                        {translate(AI_REPORT_CTA_SECTION_TRANSLATIONS.BUILD_IT)}
                    </Text>
                </Flex>

                <Flex gap="16px">
                    <Button
                        data-automation="ai-report-cta-section-talk-to-us-button"
                        onClick={handleTalkToUsClicked}
                    >
                        {translate(AI_REPORT_CTA_SECTION_TRANSLATIONS.TALK_TO_US)}
                    </Button>
                </Flex>
            </AIReportCtaSectionText>

            <AIReportCtaSectionImages />
        </StyledAIReportCtaSection>
    );
};
